import React from 'react';
import { Cookie, FileText, Shield } from 'lucide-react';
import '../styles/components/legal-footer.css';

const LEGAL_LINKS = [
  { tab: 'privacy', label: 'Política de Privacidade', Icon: Shield },
  { tab: 'cookies', label: 'Política de Cookies', Icon: Cookie },
  { tab: 'terms', label: 'Termos e Condições', Icon: FileText },
];

const LegalFooter = ({ onOpen }) => (
  <nav className="gm-legal-footer" aria-label="Informação legal">
    <span className="gm-legal-footer__label">Informação legal</span>
    <div className="gm-legal-footer__links">
      {LEGAL_LINKS.map(({ tab, label, Icon }) => (
        <button
          type="button"
          key={tab}
          className="gm-legal-footer__link"
          onClick={() => onOpen(tab)}
        >
          <Icon size={14} strokeWidth={2} aria-hidden="true" />
          {label}
        </button>
      ))}
    </div>
  </nav>
);

export default LegalFooter;
